import common from "./common.json";
import option from "./option";

export default {
  common,
  option,
};
